module.exports = __webpack_public_path__ + "img/contact_bg.b332de9.webp";